// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"afb4b7fb","191":"bcd48860","375":"f2a5315a","455":"89d33f27","488":"328ec08b","575":"f7b9d4dc","596":"1622d66a","768":"017db0f5","977":"e05582e0"}[chunkId] + ".chunk.js";
};